/* eslint-disable */
import { DIContainer } from '../container';

export function Injectable(interfaceToken?: string | Function): ClassDecorator {
  return (target: any) => {
    const container = DIContainer.getInstance();
    const creator = () => container.autoResolve(target);
    
    // 注册实现类
    container.register(target, creator, true);
    
    // 如果提供了接口，注册接口映射
    if (interfaceToken) {
      const interfaceKey = typeof interfaceToken === 'function' ? interfaceToken.name : interfaceToken;
      container.register(interfaceKey, creator, true);
    }
  };
}

export function Inject(token?: string | Function): ParameterDecorator {
  return (target: any, propertyKey: string | symbol | undefined, parameterIndex: number) => {    
    const paramTypes: any[] = Reflect.getMetadata('design:paramtypes', target) || [];
    const type = paramTypes[parameterIndex];
    
    let injectToken = token;
    
    // 如果没有指定token，尝试从类型推断
    if (!injectToken) {
      if (type && type.name && type.name !== 'Object') {
        // 如果类型是具体的类，直接使用
        injectToken = type;
      } else {
        throw new Error(`Injection token is required for interface parameter at index ${parameterIndex}`);
      }
    }
    
    // 存储参数注入信息
    const injectParams = Reflect.getMetadata('inject:params', target) || [];
    injectParams[parameterIndex] = injectToken;
    Reflect.defineMetadata('inject:params', injectParams, target);
  };
}

